import { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { auth, db } from '../firebaseConfig';
import { createUserWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import signupImage from '../assets/register.svg';
import './Auth.css';

const Signup = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!username || !email || !password) {
      setError("All fields are required!");
      return;
    }

    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // Store ONLY username and email in Firestore
      await setDoc(doc(db, "users", user.uid), {
        username: username,
        email: email
      });

      navigate('/field-selection');
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="container">
      <div className="d-grid grid-cols-2 main-container">
        <div className="form-container d-flex flex-column">
          <h2 className="form-container__title">Start your journey!</h2>
          <p>Register now and embark on your digital journey...</p>
          <NavLink className="switch-role-btn mt-1" to='/'>Switch Role</NavLink>
          {error && <p style={{ color: 'red' }}>{error}</p>}
          <form className="form-mt" onSubmit={handleSubmit}>
            <div className="input-container d-flex flex-column">
              <label htmlFor="username" className="input-label">Username</label>
              <input type="text" id="username" className="input-field"
                value={username} onChange={(e) => setUsername(e.target.value)} placeholder='Enter your username'/>
            </div>

            <div className="input-container d-flex flex-column">
              <label htmlFor="email" className="input-label">Email</label>
              <input type="email" id="email" className="input-field"
                value={email} onChange={(e) => setEmail(e.target.value)} placeholder='Enter your email'/>
            </div>

            <div className="input-container d-flex flex-column">
              <label htmlFor="password" className="input-label">Password</label>
              <input type="password" id="password" className="input-field"
                value={password} onChange={(e) => setPassword(e.target.value)} placeholder='Enter your password'/>
            </div>

            <button type="submit" className="btn-theme">SignUp</button>
          </form>

          <p className="create-account mt-1">
            Already have an account? <Link to="/login" className="text-primary">Login instead</Link>
          </p>
        </div>

        <div className="visual-container bg-primary d-flex flex-column flex-center">
          <h2 class="mt-3 visual-container__title">
              Guarding your data.
          </h2>
          <p class="visual-container__subtitle">
              Your trust, our priority. Register for a secure and seamless experience.
          </p>
          <img src={signupImage} alt="signup visual" className="img-responsive visual-container__image" />
        </div>
      </div>
    </div>
  );
};

export default Signup;